import React from 'react';
import './BigSpinner.scss';

interface Props {
  isInContainer?: Boolean;
}

export const BigSpinner = (props: Props) => {
  return (
    <div className={props.isInContainer ? 'SpinnerInnerContainer' : 'SpinnerContainer'}>
      <div className="lds-dual-ring"></div>
    </div>
  )
};
